import React, { useState } from 'react';
import {
  Collapse,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BarChartIcon from '@mui/icons-material/BarChart';
import RouteIcon from '@mui/icons-material/Route';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import PieChartIcon from '@mui/icons-material/PieChart';

import SettingsInputSvideoIcon from '@mui/icons-material/SettingsInputSvideo';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import BuildIcon from '@mui/icons-material/Build';
import TableChartIcon from '@mui/icons-material/TableChart';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import { Link, useLocation } from 'react-router-dom';
import {
  useAdministrator,
  useRestriction,
} from '../../common/util/permissions';
import useFeatures from '../../common/util/useFeatures';
import { useTranslation } from '../../common/components/LocalizationProvider';

const MenuItem = ({ title, link, icon, selected, sx }) => (
  <ListItemButton
    key={link}
    component={Link}
    to={link}
    selected={selected}
    sx={sx}
  >
    <ListItemIcon>{icon}</ListItemIcon>
    <ListItemText primary={title} />
  </ListItemButton>
);
const CollapseMenuItem = ({ title, icon, onClick, endAdornment }) => (
  <ListItemButton onClick={onClick}>
    <ListItemIcon>{icon}</ListItemIcon>
    <ListItemText primary={title} />
    {endAdornment}
  </ListItemButton>
);

const ReportsMenu = () => {
  const t = useTranslation();
  const location = useLocation();

  const admin = useAdministrator();
  const readonly = useRestriction('readonly');
  /* NEW */
  const features = useFeatures();

  const [openCorporate, setOpenCorporate] = useState(false);
  const handleOpenCorporate = () => {
    setOpenCorporate(!openCorporate);
  };

  return (
    <>
      <List>
        <MenuItem
          title={t('reportRoute')}
          link="/reports/route"
          icon={<TimelineIcon />}
          selected={location.pathname === '/reports/route'}
        />
        <MenuItem
          title={t('reportEvents')}
          link="/reports/event"
          icon={<NotificationsActiveIcon />}
          selected={location.pathname === '/reports/event'}
        />
        <MenuItem
          title={t('reportTrips')}
          link="/reports/trip"
          icon={<PlayCircleFilledIcon />}
          selected={location.pathname === '/reports/trip'}
        />
        <MenuItem
          title={t('reportStops')}
          link="/reports/stop"
          icon={<PauseCircleFilledIcon />}
          selected={location.pathname === '/reports/stop'}
        />
        <MenuItem
          title={t('reportSummary')}
          link="/reports/summary"
          icon={<FormatListBulletedIcon />}
          selected={location.pathname === '/reports/summary'}
        />
        <MenuItem
          title={t('reportChart')}
          link="/reports/chart"
          icon={<PieChartIcon />}
          selected={location.pathname === '/reports/chart'}
        />
        <MenuItem
          title={t('reportReplay')}
          link="/replay"
          icon={<RouteIcon />}
        />
      </List>
      {(admin || !readonly) && (
        <>
          <Divider />
          <List>
            <MenuItem
              title={t('reportScheduled')}
              link="/reports/scheduled"
              icon={<EventRepeatIcon />}
              selected={location.pathname === '/reports/scheduled'}
            />
            {admin && (
              <MenuItem
                title={t('statisticsTitle')}
                link="/reports/statistics"
                icon={<BarChartIcon />}
                selected={location.pathname === '/reports/statistics'}
              />
            )}
          </List>
        </>
      )}

      <Divider />
      <List>
        <MenuItem
          title={t('reportHeavyDuty')}
          link="/reports/heavyDuty"
          icon={<SettingsInputSvideoIcon />}
          selected={location.pathname === '/reports/heavyDuty'}
        />
        <MenuItem
          title={t('reportMaintenances')}
          link="/reports/maintenances"
          icon={<BuildIcon />}
          selected={location.pathname.startsWith('/reports/maintenances')}
        />
      </List>

      {(admin || !features.disableCorporateReports) && (
        <>
          <Divider />
          <List>
            <CollapseMenuItem
              title={t('reportCorporate')}
              icon={<BusinessCenterIcon />}
              onClick={handleOpenCorporate}
              endAdornment={openCorporate ? <ExpandLess /> : <ExpandMore />}
            />
            <Collapse
              in={
                openCorporate ||
                location.pathname.startsWith('/reports/corporate')
              }
              timeout="auto"
              unmountOnExit
            >
              <MenuItem
                title={t('reportAssetsStatus')}
                link="/reports/corporate/status"
                icon={<TableChartIcon />}
                selected={location.pathname === '/reports/corporate/status'}
                onClick={() => { }}
                endAdornment={openCorporate ? <ExpandLess /> : <ExpandMore />}
                sx={{ pl: 4 }}
              />
              <MenuItem
                title={t('statisticsTitle')}
                link="/reports/corporate/statistics"
                icon={<BarChartIcon />}
                selected={location.pathname === '/reports/corporate/statistics'}
                onClick={() => { }}
                endAdornment={openCorporate ? <ExpandLess /> : <ExpandMore />}
                sx={{ pl: 4 }}
              />
              <MenuItem
                title={t('reportProductionGoals')}
                link="/reports/corporate/goals"
                icon={<QueryStatsIcon />}
                selected={location.pathname === '/reports/corporate/goals'}
                onClick={() => { }}
                endAdornment={openCorporate ? <ExpandLess /> : <ExpandMore />}
                sx={{ pl: 4 }}
              />
              <MenuItem
                title={t('reportPerformance')}
                link="/reports/corporate/performance"
                icon={<TrendingUpIcon />}
                selected={
                  location.pathname === '/reports/corporate/performance'
                }
                onClick={() => { }}
                endAdornment={openCorporate ? <ExpandLess /> : <ExpandMore />}
                sx={{ pl: 4, mb: 6 }}
              />
            </Collapse>
          </List>
        </>
      )}
    </>
  );
};

export default ReportsMenu;
